module["exports"] = ["nl", "com", "net", "org", "eu"];